import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function RichListItemAddon(props: Props) {
  return <div>{props.children}</div>;
}
